import React from 'react';
import styled from 'styled-components';
import fhm6_logo from '../../../assets/images/sponsors/fhm6_logo.png';
import { PrimaryButton, SecondaryButton } from '../../../components/buttons';
import { useMediaQuery } from 'react-responsive';
import { mobileBreakpoint } from '../../../lib';
import { Row, Col } from '../../../components/layout';
import { Separator } from '../../../components/presentation';
import { PresentedBy } from '../../../components';

const SubHeaderContainer = styled(Row)`
    padding: 25px 0px;
`;

const FullWidthBorder = styled.div`
    left: 0;
    width: 100%;
    position: absolute;
    height: 3px;
    background-color: #d6001c;
`;

const ExitIconContainer = styled.div`
    cursor: pointer;
`;

const BreakpointCol = styled(Col)`
    @media (max-width: 900px) {
        visibility: hidden;
        display: none;
    }
`;

const SubHeading = styled.div`
    margin: 0;
    display: inline-block;
    text-transform: uppercase;
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 20px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 26px;
    @media (max-width: 900px) {
        font-size: 16px;
    }
`;

function Header({ heading, subHeading, openSaveModal, handleOpenExitModal, userCanSave, sponsorLogo }){
    const isMobile = useMediaQuery({maxWidth: mobileBreakpoint});
    return (
        <ActionHeader 
            heading={heading}
            subHeading={subHeading}
            handleOpenExitModal={handleOpenExitModal}
            sponsorLogo={sponsorLogo}
        >
            {userCanSave && <PrimaryButton margin={isMobile ? '0 0 0 0' : '0 40px 0 0'} padding={isMobile ? '13px 20px' : '10px 30px' }onClick={openSaveModal}>Save Results</PrimaryButton>}
        </ActionHeader>
    );
}

function ActionHeader({ heading, subHeading, children, sponsorLogo, handleOpenExitModal }){
    const isMobile = useMediaQuery({ maxWidth: mobileBreakpoint });
    return (
    <>
        <FullWidthBorder />
        <Row justifyContent="space-between" alignItems="center">
            <Col alignItems="center">
                <h1>{heading}</h1>
            </Col>
            {isMobile && <Col alignItems="center">
                <ExitIconContainer>
                <svg width="25px" height="25px" viewBox="0 0 35 35" version="1.1" onClick={handleOpenExitModal}>
                    <g id="Icon/close/2px">
                        <path d="M19.0909 0L0 19.0909L19.0909 0Z" transform="translate(7.954545 7.954545)" id="Path-3-Copy-4" fill="none" stroke="#d6001c" strokeWidth="2" />
                        <path d="M19.0909 19.0909L0 0L19.0909 19.0909Z" transform="translate(7.954545 7.954545)" id="Path-3-Copy-5" fill="none" stroke="#d6001c" strokeWidth="2" />
                    </g>
                </svg>    
            </ExitIconContainer>
            </Col>}
            <BreakpointCol alignItems="center">
                {children}
                <SecondaryButton onClick={handleOpenExitModal}>Exit</SecondaryButton>
            </BreakpointCol>
        </Row>
        {isMobile &&
        <>
            <Separator />
            <SubHeaderContainer justifyContent="center" alignItems="center" padding="17px 0px">
                <Col alignItems="center">
                    <PresentedBy logo={sponsorLogo || fhm6_logo} />
                </Col>
            </SubHeaderContainer>
            <Separator />
        </>
        }
        {!isMobile && <Separator />}
            <SubHeaderContainer justifyContent="space-between" alignItems="center">
                <Col justifyContent="space-between">
                    <SubHeading>{subHeading}</SubHeading>
                </Col>
                <Col>
                {isMobile ? children : <Col alignItems="center">
                    <PresentedBy logo={sponsorLogo || fhm6_logo} />
                </Col>}
                </Col>
            </SubHeaderContainer>
        {!isMobile && <Separator />}
    </>
    );
}

export default Header;